import { useEffect } from "react";
import { useLocation } from "react-router";

// Client-side routing doesn't trigger the browser's native "jump to #anchor"
// behavior, and several profile pages (AgencyProfilePage, CompanyProfilePage)
// are linked-to via #section-* hashes from elsewhere (e.g. the owner-listings
// nav tabs) whose target sections only exist once that page's data has
// loaded — so a single scrollIntoView on mount can fire before the element
// exists. Retry briefly instead of giving up immediately.
export function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = hash.slice(1);
    let attempts = 0;
    const maxAttempts = 20; // ~2s at 100ms intervals

    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      attempts += 1;
      if (attempts < maxAttempts) {
        setTimeout(tryScroll, 100);
      }
    };

    tryScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash, pathname]);

  return null;
}
